/**
 * @param {object} appointmentStore - pinia appointment store
 * @param {string} clientId
 * @param {string} serviceId
 */
export function getLastVisitSupplies(appointmentStore, clientId, serviceId) {
  if (!appointmentStore?.appointments) return [];
  return findLastVisitSuppliesFromStore(appointmentStore.appointments, clientId, serviceId);
}

/**
 * @param {Record<string, object>} appointments
 * @param {string} clientId
 * @param {string} serviceId
 */
export function findLastVisitSuppliesFromStore(appointments, clientId, serviceId) {
  const sorted = Object.values(appointments || {})
    .filter((a) => a.client === clientId && isPaid(a.paid))
    .sort((a, b) => (Number(b.date) || 0) - (Number(a.date) || 0));

  for (const appt of sorted) {
    const services = Array.isArray(appt.services) ? appt.services : [];
    if (!services.some((s) => s.service === serviceId)) continue;
    const usage = Array.isArray(appt.supplyUsage) ? appt.supplyUsage : [];
    const forService = usage.filter((u) => u.serviceId === serviceId);
    if (forService.length > 0) {
      return forService.map((u) => ({ ...u }));
    }
  }
  return [];
}

function isPaid(paid) {
  return paid !== '' && paid != null && paid !== undefined;
}
